<template>
  <div class="background">
    <div class="login-div">
      <div class="login">
        <h1>天津英语单词查询</h1>
        <div style="display: flex;justify-content: center;margin-bottom: 0px">
          <img src=".././assets/study.png" width="30px" height="30px">
        </div>
        <van-row style="color: lightgray; margin-top: -10px; margin-bottom: 5px;font-size: 10px">
          <van-col span="17">免费使用</van-col>
        </van-row>
        <div class="home-word-status" :class="{ 'has-update': updateAvailable }">
          <div class="home-word-status-main">
            <van-loading
                v-if="wordStatusBusy"
                class="home-word-status-icon"
                type="spinner"
                size="20px"
                color="#1989fa"
            />
            <van-icon
                v-else
                class="home-word-status-icon"
                :name="updateAvailable ? 'upgrade' : 'passed'"
                :color="updateAvailable ? '#ed6a0c' : '#07c160'"
                size="21"
            />
            <div class="home-word-status-copy">
              <strong>{{ wordStatusTitle }}</strong>
              <span>{{ wordStatusDetail }}</span>
            </div>
          </div>
          <van-button
              v-if="updateAvailable"
              class="home-word-update-button"
              type="warning"
              size="small"
              round
              :loading="updatingWords"
              loading-text="更新中"
              @click="updateWords"
          >立即更新</van-button>
        </div>
        <div class="home-word-search">
          <div class="home-word-search-title">
            <span>快速查询单词</span>
            <span v-if="wordStatusBusy" class="home-word-loading">
              <van-loading type="spinner" size="12px" color="#ed6a0c" />
              词库加载中...
            </span>
            <span v-else class="home-word-ready">3500 词库</span>
          </div>
          <van-field
              v-model="homeSearchText"
              class="home-word-search-field"
              left-icon="search"
              clearable
              autocomplete="off"
              placeholder="输入完整英文单词，如：study"
              @input="openHomeSuggestions"
              @focus="openHomeSuggestions"
              @blur="closeHomeSuggestions"
              @keydown.native.down.prevent="moveHomeSuggestion(1)"
              @keydown.native.up.prevent="moveHomeSuggestion(-1)"
              @keydown.native.esc.prevent="hideHomeSuggestions"
              @keydown.native.enter.prevent="handleHomeSearchEnter"
          >
            <template #button>
              <van-button
                  size="small"
                  type="info"
                  round
                  :loading="words3500Loading"
                  @click="searchHomeWord"
              >查询</van-button>
            </template>
          </van-field>
          <div v-if="showHomeSuggestions" class="home-suggestion-panel">
            <div class="home-suggestion-header">
              <span>联想词 · 点击填入</span>
              <span>{{ homeWordSuggestions.length }} 个</span>
            </div>
            <div class="home-suggestion-list" role="listbox">
              <button
                  v-for="(item, index) in homeWordSuggestions"
                  :key="item.word"
                  type="button"
                  class="home-suggestion-item"
                  :class="{ active: index === activeHomeSuggestionIndex }"
                  role="option"
                  :aria-selected="index === activeHomeSuggestionIndex"
                  @mousedown.prevent="selectHomeSuggestion(item.word)"
                  @click="selectHomeSuggestion(item.word)"
                  @mouseenter="activeHomeSuggestionIndex = index"
              >
                <span class="home-suggestion-word">
                  <strong>{{ homeSuggestionPrefix(item.word) }}</strong>{{ homeSuggestionSuffix(item.word) }}
                </span>
                <span class="home-suggestion-meta">
                  <span v-if="item.attribute" class="home-suggestion-attribute">{{ item.attribute }}</span>
                  <span class="home-suggestion-meaning">{{ item.meaning }}</span>
                </span>
              </button>
            </div>
          </div>
        </div>
        <div>
          <b-button class="signin-button" variant="danger" @click="gotoFilter()">教材查询（初中适用）</b-button>
        </div>
        <div>
          <b-button class="signup-button" variant="warning" @click="gotoLogin()">高考3500（高中适用）</b-button>
        </div>
        <hr>
        <div style="font-size: 8px;color: bisque;">
           <div>&nbsp;&nbsp;数据源于:</div>
          <div>《普通高等学校招生全国统一考试（天津卷）英语常用词词汇手册》</div>
          <!-- <div>&nbsp;&nbsp;统一考试（天津卷）英语常用词词汇手册》</div> -->
          <div>《外研社义务教育教科书》</div>
          <div>《外研社普通高中教科书》</div>
        </div>
        <!-- <div>
          <b-button class="resetPassword-button mb-2" variant="outline-info" @click="logout()">
            <b-icon icon="power" aria-hidden="true"></b-icon> {{ $store.state.userShow }}
          </b-button>
        </div> -->
      </div>

      <div class="beian">
        <a class="beian1" href="http://beian.miit.gov.cn/" target="_blank">津ICP备2021007309号-1</a>
        <a class="beian2" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=12010102001035">
          <img class="img-beian" src=".././assets/beian.png" alt="" width="12px" height="12px">
          <p>津公网安备 12010102001035号</p>
        </a>
        <div style="display: flex;justify-content: center;align-items: center;flex-direction: column;">
          <!-- <div style="">网络信息举报电话:13110028644</div> -->
          <div class="">网络信息举报邮箱:179254624@qq.com</div>
        </div>
      </div>

    </div>


  </div>


</template>
<script>
import { Toast } from 'vant';
import axios from 'axios';
import $ from 'jquery'
import { queryWordFamily } from '../utils/wordFamily'

export default {
  name: 'homepage',
  components: {},
  data(){
    return {
      homeSearchText: '',
      homeSuggestionsOpen: false,
      activeHomeSuggestionIndex: -1,
      words3500Loading: false,
      words3500LoadPromise: null,
      checkingUpdate: false,
      updateAvailable: false,
      updatingWords: false,
    }
  },
  methods: {
    async ensureWords3500(){
      if(Array.isArray(this.$store.state.gaokaoWords) && this.$store.state.gaokaoWords.length){
        return true;
      }

      const cachedWords = this.commonApi.readWordCache('words3500');
      if(cachedWords){
        this.$store.state.gaokaoWords = cachedWords.data;
        return true;
      }

      if(this.words3500LoadPromise)return this.words3500LoadPromise;
      this.words3500Loading = true;
      this.$store.state.loadingWords3500 = true;
      this.words3500LoadPromise = (async () => {
        try{
          // 先让 Vue 渲染一帧，确保真机首页能看到加载圈。
          await this.$nextTick();
          const words3500Data = this.commonApi.getInitialWords3500();
          this.$store.state.gaokaoWords = words3500Data.data;
          this.commonApi.writeWordCache('words3500', words3500Data);
          return true;
        }catch(error){
          Toast.fail('3500词库加载失败，请稍后重试');
          return false;
        }finally{
          this.words3500Loading = false;
          this.$store.state.loadingWords3500 = false;
        }
      })();
      const loaded = await this.words3500LoadPromise;
      this.words3500LoadPromise = null;
      return loaded;
    },
    async ensureWordDictionaries(){
      const gaokaoReady = await this.ensureWords3500();
      if(!gaokaoReady)return false;
      if(Array.isArray(this.$store.state.newWords) && this.$store.state.newWords.length){
        return true;
      }
      try{
        const cachedWords = this.commonApi.readWordCache('newWords');
        const wordsData = cachedWords || this.commonApi.getInitialNewWords();
        this.$store.state.newWords = wordsData.data;
        this.commonApi.writeWordCache('newWords', wordsData);
        return true;
      }catch(error){
        Toast.fail('教材词库加载失败，请稍后重试');
        return false;
      }
    },
    async checkForWordUpdates(){
      const cacheTargets = [
        { cacheKey: 'newWords', method: 'newWords' },
        { cacheKey: 'words3500', method: 'words3500' }
      ];
      const targets = cacheTargets
          .map(target => Object.assign({}, target, {
            cachedData: this.commonApi.readWordCache(target.cacheKey)
          }))
          .filter(target => target.cachedData && target.cachedData.version !== undefined);

      if(!targets.length)return;
      this.checkingUpdate = true;
      try{
        const results = await Promise.all(targets.map(target => {
          const params = new URLSearchParams();
          params.append('method', target.method);
          params.append('version', target.cachedData.version);
          return axios.post('ifUpdate/', params).then(response => response.data === true);
        }));
        this.updateAvailable = results.some(Boolean);
        const updateByMethod = {};
        targets.forEach((target, index) => {
          updateByMethod[target.method] = results[index];
        });
        this.$store.state.tagShowWords = updateByMethod.newWords === true;
        this.$store.state.tagShow3500 = updateByMethod.words3500 === true;
      }catch(error){
        // 离线时继续使用内置词库，不用错误提示打断首页使用。
        console.warn('词库更新检查失败', error);
      }finally{
        this.checkingUpdate = false;
      }
    },
    async updateWords(){
      if(this.updatingWords)return;
      this.updatingWords = true;
      this.$store.state.loadingWords = true;
      this.$store.state.loadingWords3500 = true;
      try{
        const [newWordsData, words3500Data] = await Promise.all([
          this.commonApi.getNewWords(),
          this.commonApi.getWords3500()
        ]);
        this.$store.state.newWords = newWordsData.data;
        this.$store.state.gaokaoWords = words3500Data.data;
        this.commonApi.writeWordCache('newWords', newWordsData);
        this.commonApi.writeWordCache('words3500', words3500Data);
        this.$store.state.tagShowWords = false;
        this.$store.state.tagShow3500 = false;
        this.updateAvailable = false;
        Toast.success('词库更新成功');
      }catch(error){
        console.error('首页词库更新失败', error);
        Toast.fail('更新失败，已保留原有词库');
      }finally{
        this.$store.state.loadingWords = false;
        this.$store.state.loadingWords3500 = false;
        this.updatingWords = false;
      }
    },
    openHomeSuggestions(){
      this.homeSuggestionsOpen = (this.homeSearchText || '').trim().length > 0;
      this.activeHomeSuggestionIndex = -1;
    },
    closeHomeSuggestions(){
      window.setTimeout(() => this.hideHomeSuggestions(), 180);
    },
    hideHomeSuggestions(){
      this.homeSuggestionsOpen = false;
      this.activeHomeSuggestionIndex = -1;
    },
    moveHomeSuggestion(step){
      if(!this.showHomeSuggestions)this.openHomeSuggestions();
      const count = this.homeWordSuggestions.length;
      if(!count)return;
      if(this.activeHomeSuggestionIndex < 0){
        this.activeHomeSuggestionIndex = step > 0 ? 0 : count - 1;
        return;
      }
      this.activeHomeSuggestionIndex =
          (this.activeHomeSuggestionIndex + step + count) % count;
    },
    selectHomeSuggestion(word){
      this.homeSearchText = word;
      this.hideHomeSuggestions();
    },
    handleHomeSearchEnter(){
      if(this.showHomeSuggestions && this.activeHomeSuggestionIndex >= 0){
        this.selectHomeSuggestion(
            this.homeWordSuggestions[this.activeHomeSuggestionIndex].word
        );
        return;
      }
      this.searchHomeWord();
    },
    homeSuggestionPrefix(word){
      return word.slice(0, (this.homeSearchText || '').trim().length);
    },
    homeSuggestionSuffix(word){
      return word.slice((this.homeSearchText || '').trim().length);
    },
    async searchHomeWord(){
      const keyword = (this.homeSearchText || '').trim().toLowerCase();
      if(!keyword){
        Toast.fail('请输入完整英文单词');
        return;
      }
      const ready = await this.ensureWordDictionaries();
      if(!ready)return;

      const lookup = queryWordFamily(
          keyword,
          this.$store.state.newWords,
          this.$store.state.gaokaoWords
      );
      if(lookup.mode === 'invalid'){
        Toast.fail('请输入单个英文单词');
        return;
      }
      if(lookup.mode === 'none'){
        Toast.fail(`词库中未查询到“${keyword}”或相关派生词`);
        return;
      }
      this.hideHomeSuggestions();
      this.$store.state.filterResult = lookup.results;
      this.$store.state.filterResultMeta = { mode: lookup.mode, query: lookup.query };
      this.$router.push({ name: 'wordsList', params: { typeShow: 'family' }});
    },
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
    gotoFilter(){
      if(this._isMobile()) {
        this.$router.push({name: 'filterWords', params: {}});
      }else{
        this.$router.push({ name: 'homepage_pc'});
      }
    },
    logout(){
      if(this._isMobile()){
        window.localStorage.removeItem('Authorization3500');
        this.$router.push({ name: 'login'});
      }else{
        window.localStorage.clear();
        this.$router.push({ name: 'login_pc'});
      }
    },
    // 跳转3500filter
    gotoLogin(){
      if(this._isMobile()){
        this.$router.push({ name: 'filter3500', params: {}});
      }else{
        this.$router.push({ name: 'homepage_pc'});
      }

    },

  },
  watch: {
  },
  computed: {
    wordStatusBusy(){
      return this.words3500Loading ||
          this.$store.state.loadingWords ||
          this.$store.state.loadingWords3500 ||
          this.checkingUpdate ||
          this.updatingWords;
    },
    wordStatusTitle(){
      if(this.updatingWords)return '正在更新词库';
      if(this.words3500Loading || this.$store.state.loadingWords || this.$store.state.loadingWords3500){
        return '正在加载单词';
      }
      if(this.checkingUpdate)return '正在检查词库更新';
      if(this.updateAvailable)return '发现新的词汇数据';
      return '词库已准备好';
    },
    wordStatusDetail(){
      if(this.updatingWords)return '正在下载教材与高考 3500 词汇，请稍候';
      if(this.wordStatusBusy)return '加载过程中仍可停留在首页查看进度';
      if(this.updateAvailable)return '点击右侧按钮即可更新到最新词库';
      const newWordsCount = Array.isArray(this.$store.state.newWords)
          ? this.$store.state.newWords.length
          : 0;
      const words3500Count = Array.isArray(this.$store.state.gaokaoWords)
          ? this.$store.state.gaokaoWords.length
          : 0;
      return `教材 ${newWordsCount} 词 · 高考 ${words3500Count} 词`;
    },
    homeWordSuggestions(){
      const keyword = (this.homeSearchText || '').trim().toLowerCase();
      const words = Array.isArray(this.$store.state.gaokaoWords)
          ? this.$store.state.gaokaoWords
          : [];
      if(!keyword)return [];

      const uniqueWords = new Map();
      words.forEach(item => {
        const word = item && item['英文'] ? item['英文'].toString().trim() : '';
        const normalizedWord = word.toLowerCase();
        if(word && normalizedWord.indexOf(keyword) === 0 && !uniqueWords.has(normalizedWord)){
          uniqueWords.set(normalizedWord, {
            word: word,
            attribute: item['词性'] || '',
            meaning: item['中文'] || ''
          });
        }
      });
      return Array.from(uniqueWords.values())
          .sort((a, b) => a.word.length - b.word.length || a.word.localeCompare(b.word))
          .slice(0, 8);
    },
    showHomeSuggestions(){
      return this.homeSuggestionsOpen && this.homeWordSuggestions.length > 0;
    }
  },
  activated() {
  },
  async mounted() {
    // 更改css
    $(".van-nav-bar__right").css({'padding': '0px'});
    await this.ensureWords3500();
    await this.$nextTick();
    this.checkForWordUpdates();
  },

}
</script>

<style scoped>
/*@import '../assets/login.css';*/
  .fade-leave-to{
    opacity:0;
    transform: translate3d(0,30px,0);
    position: absolute;
    z-index: -10;
  }
  .fade-enter{
    transform: translate3d(0,0px,0);
    position: absolute;
  }
  .fade-leave-active{
    transition: 2.5s all ease;
  }
  .fade-enter-active{
    transition: opacity 1.5s;
  }
  .van-nav-bar__left, .van-nav-bar__right{
    padding-left: 0px;
  }

.background {
  margin: 0;
  padding: 0;
  /*background: url(".././assets/shoolkids.jpg") no-repeat center center;*/
  /*background: url(".././assets/table2.jpg") no-repeat center center;*/
  /*background: linear-gradient(to top right, #65349D, #3D39AC, #6ECFCF);*/
  background: #220B15;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  height: 100%;
  display: flex;
  /* flex-direction: column;
  justify-content: space-between; */
  justify-content: center;
  align-items: center
}

.login {
  /*margin: auto;*/

  width: 500px;
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 5px;
  padding: 50px 70px 200px 70px;
}

.login h1 {
  color: white;
  padding-bottom: 30px;
}

.beian {
  margin-top: 10%;
  font-size: 8px;
  background: #220B15;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center
}
.beian1 {
  background: none;
  color: white;
}
.beian2 {
  display: flex;
  text-decoration:none;
  line-height:20px;
  background: none;
  color: white;
}

.home-word-search {
  margin: 16px 0 4px;
  overflow: hidden;
  border: 2px solid #1989fa;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 6px 20px rgba(25, 137, 250, 0.28);
}

.home-word-status {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 58px;
  margin: 12px 0 4px;
  padding: 10px 12px;
  border: 1px solid rgba(25, 137, 250, 0.35);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 5px 16px rgba(0, 0, 0, 0.14);
}

.home-word-status.has-update {
  border-color: #ffb66e;
  background: #fff8f0;
}

.home-word-status-main {
  display: flex;
  align-items: center;
  min-width: 0;
}

.home-word-status-icon {
  flex: 0 0 auto;
  margin-right: 10px;
}

.home-word-status-copy {
  display: flex;
  flex-direction: column;
  min-width: 0;
  color: #323233;
  text-align: left;
}

.home-word-status-copy strong {
  font-size: 13px;
  line-height: 20px;
}

.home-word-status-copy span {
  overflow: hidden;
  color: #7d7e80;
  font-size: 10px;
  line-height: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.home-word-update-button {
  flex: 0 0 auto;
  margin-left: 8px;
}

.home-word-search-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9px 13px 5px;
  color: #323233;
  font-size: 14px;
  font-weight: 700;
}

.home-word-ready,
.home-word-loading {
  padding: 2px 7px;
  border-radius: 9px;
  font-size: 10px;
  font-weight: 400;
}

.home-word-ready {
  color: #1989fa;
  background: #ecf6ff;
}

.home-word-loading {
  color: #ed6a0c;
  background: #fff4e8;
  display: flex;
  align-items: center;
  gap: 4px;
}

.home-word-search-field {
  padding-top: 7px;
  padding-bottom: 10px;
}

.home-suggestion-panel {
  border-top: 1px solid #d9e9fb;
  background: #fff;
}

.home-suggestion-header {
  display: flex;
  justify-content: space-between;
  padding: 7px 13px;
  color: #7d8b99;
  font-size: 11px;
  background: #f7faff;
}

.home-suggestion-list {
  max-height: 280px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.home-suggestion-item {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 56px;
  padding: 8px 12px;
  border: 0;
  border-top: 1px solid #f1f3f5;
  color: #323233;
  text-align: left;
  background: #fff;
  cursor: pointer;
}

.home-suggestion-item.active,
.home-suggestion-item:active {
  background: #edf7ff;
}

.home-suggestion-word {
  flex: 0 0 36%;
  padding-right: 8px;
  overflow: hidden;
  font-size: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.home-suggestion-word strong {
  color: #1989fa;
}

.home-suggestion-meta {
  display: flex;
  align-items: center;
  min-width: 0;
  color: #7d7e80;
  font-size: 12px;
}

.home-suggestion-attribute {
  flex: 0 0 auto;
  margin-right: 6px;
  padding: 2px 4px;
  border-radius: 4px;
  color: #1989fa;
  background: #ecf6ff;
}

.home-suggestion-meaning {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.img-beian{
  margin: 4px 1px 0 2px;
}

.signin-button {
  margin-top: 20px;
  height: 60px;
  width: 100%;
  padding: 13px;
  border-radius: 5px;
  background-color: red;
  color: white;
  border: none;
  font-weight: bold;
  font-size: 1.05rem;
  cursor: pointer;
}

.signup-button {
  margin-top: 20px;
  height: 60px;
  width: 100%;
  padding: 13px;
  border-radius: 5px;
  background-color: #d39e00;
  color: white;
  border: none;
  font-weight: bold;
  font-size: 1.05rem;
  cursor: pointer;
}

.resetPassword-button {
  margin-top: 10px;
  width: 100%;
  height: 60px;
  padding: 13px;
  border-radius: 5px;
  background-color: #007bff;
  color: white;
  border: none;
  font-weight: bold;
  font-size: 1.05rem;
  cursor: pointer;
}
.remember-flex {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  font-size: 0.8rem;
}

.warning-input {
  visibility: hidden;
  /* display: none; */
  color: rgb(232, 3, 3);
  font-weight: 700;
  font-size: 0.8rem;
  margin-top: 10px;
}

.signup-link:hover {
  text-decoration: underline;
}

.log_face {
  text-decoration: none;
  margin-left: 10px;
  font-size: 0.8rem;
}

.login-face {
  margin: 50px 0 15px 0;
  vertical-align: middle;
  color: #8c8c8c;
}

.protection {
  font-size: 0.8rem;
  color: #8c8c8c;
}

.protection a {
  text-decoration: none;
}

.protection a:hover {
  text-decoration: underline;
}

@media screen and (max-width: 740px) {
  .login h1 {
    color: white;
    padding-bottom: 10px;
    font-size: 20px;
  }
  .img-logo {
    margin-left: 22px;
  }
  .login {
    padding: 40px 30px 153px 30px;
    width: 65%;
    height: 90%;
    /*align-self: center;*/
    margin-left: 20%;
  }
  .login-div {
    width: 90%;
    margin: 10px auto;
  }
  /*.beian {*/
  /*  width: 50%;*/
  /*  margin-top: 10%;*/
  /*  margin-left: 21%;*/
  /*}*/
}
/*手机*/
@media screen and (max-width: 500px) {
  .background {
    min-height: 100vh;
    height: auto;
    align-items: flex-start;
  }
  .login h1 {
    color: white;
    align-self: center;
  }
  .login {
    box-sizing: border-box;
    width: 90%;
    align-self: center;
    padding: 32px 24px 70px;
    margin: 5% auto 20%;
  }
  .beian {
    width: 60%;
    margin-left: 20%;
    margin-top: 5%;
  }
}
</style>
